import React, { useContext } from 'react'
import { Context } from './Context'
import { MdLaunch } from 'react-icons/md'

const Employee = ({ _id, name, title, education }) => {
  const { set$active } = useContext(Context)

  const showDetails = education?.length > 0

  return (
    <li className="text-lg">
      <div className="h3">
        {showDetails
          ? (
            <button className="group with-icon" onClick={() => set$active(_id)}>
            {name}
            <MdLaunch className="group-hover:text-ft-green transition-colors" />
          </button>
          )
          : name
        }
      </div>
      <div className="technical">{title}</div>
    </li>
  )
}

export default Employee
